import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  dashboardActions,
  mappingActions,
  UserloyalityLogRptActions,
} from "../actions";
import tableRequest from "../models/tableRequest.js";
import ReactApexChart from "react-apexcharts";
import "./Sidebar.css";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    // horizontal bar chart
    this.tblResponse = new tableRequest();
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.state = {
      // Initialize state to manage the visibility of the card
      isCardVisible: false,
      globalFilter: null,
      first: 0,
      rows: 5,
      totalRecords: 0,
      sortOrder: "",
      loading: false,
      visibleRight: false,
      DealerNameList: [],
      DealerQtyList: [],
      categories: [],
      data: [],
      // dealerwiseStockChart: {
      //   options: {
      //     chart: { type: "area" },
      //     xaxis: { categories: [] }, // Initialize empty array
      //   },
      //   series: [], // Initialize empty series
      // },

      
      dealerwiseStockChart: {
        options: {
          chart: {
            type: "area",
            height: 250,
            toolbar: { show: false },
          },
          xaxis: { categories: [] }, // Empty initially
          yaxis: { labels: { formatter: (value) => value.toFixed(0) } },
          dataLabels: { enabled: false },
          stroke: { curve: "smooth", width: 2 },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.3,
              stops: [0, 90, 100],
            },
          },
          colors: ["#156089"],
          tooltip: { theme: "dark" },
        },
        series: [],
      },



      series: [
        { name: "Mapping", data: [] },
        { name: "DeMapping", data: [] },
      ],
      options: {
        chart: {
          height: 600,
          width: 800,
          type: "area",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        },
      },

      mappingTrends: {
        series: [],
        MonthName: [],
      },
      topLoyal: [],
      topLoyaltyAchieverChart: {
        series: [],
        options: {
          chart: {
            type: "bar",
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          title: {
            // text: "Top Loyalty Achievers",
            align: "left",
          },
          xaxis: {
            categories: [],
          },
          fill: {
            opacity: 0.8,
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "50%",
            },
          },
          dataLabels: {
            enabled: true,
            style: {
              colors: ["#fff"],
            },
          },
          tooltip: {
            theme: "dark",
            y: {
              formatter: (value) => `${value} Points`,
              title: {
                formatter: () => '',
              },
            },
          },
          colors: ["#1E90FF", "#FF6347"],
          legend: {
            position: "top",
            horizontalAlign: "center",
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  height: 300,
                },
                plotOptions: {
                  bar: {
                    columnWidth: "70%",
                  },
                },
              },
            },
          ],
        },
      },
    };
  }

  updateTopLoyaltyAchieverChart = (categories, data) => {
    
    this.setState((prevState) => ({
      topLoyaltyAchieverChart: {
        ...prevState.topLoyaltyAchieverChart,
        options: {
          ...prevState.topLoyaltyAchieverChart.options,
          xaxis: {
            ...prevState.topLoyaltyAchieverChart.options.xaxis,
            categories: categories,
          },
        },
        series: [
          {
            data: data,
          },
        ],
      },
    }));
  };

  updateDealerwiseStockChart = (categories, data) => {
    if ((!categories && !data) || (categories.length && data.length === 0))
      return;

    this.setState((prevState) => ({
      dealerwiseStockChart: {
        ...prevState.dealerwiseStockChart,
        options: {
          ...prevState.dealerwiseStockChart.options,
          chart: {
            type: "area",
            height: 350,
          },
          plotOptions: {
            bar: {
              horizontal: true,
              dataLabels: { position: "top" },
            },
          },
          xaxis: {
            categories: categories,
          },
          yaxis: {
            labels: {
              formatter: (value, index) => data[index]?.value || "",
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: (value) => `Qty: ${value}`,
            },
          },
          colors: ["#008FFB", "#00E396", "#FEB019", "#00E396", "#FEB019"], // Different colors for dealers
        },
       
        series: data.map((item) => ({
        
          name: item.name, // Dealer name
          data: item.values, // Match reversed months
          
        })),
    
      },
      
    }));
  };

  componentDidMount() {
    if (!sessionStorage.getItem("reloaded")) {
      sessionStorage.setItem("reloaded", "true");
      window.location.reload();
    }
    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
      const Curenturl = window.location.pathname;
      const nNumber = Curenturl.lastIndexOf("/");

      const pageName = Curenturl.substring(nNumber + 1);

      const obj = assignedPermissions.assigned.filter((x) => {
        return x.ActionName === pageName;
      });

      if (obj !== null && obj.length > 0) {
        if (!obj[0].IsEdit) {
          this.setState({
            IsEdit: false,
          });
        }
        if (!obj[0].IsAdd) {
          this.setState({
            IsAdd: false,
          });
        }
      }
    }
    this.props.fetchApi(this.tblResponse);
    this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchLoyalityApi(this.tblResponse);
    this.props.TopfetchLoyalityPointApi(this.tblResponse);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.Dealerstocks !== this.props.Dealerstocks &&
      this.props.Dealerstocks
    ) {
      ;
      const categories = this.props.Dealerstocks.map((item) => item.Month);

      const allKeys = new Set();

      // Iterate through all objects in Dealerstocks
      this.props.Dealerstocks.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (key !== "Month") allKeys.add(key); // Exclude "Month" key
        });
      });

      const seriesNames = Array.from(allKeys); // Convert Set to Array

      const seriesData = seriesNames.map((name) => ({
        name,
        values: this.props.Dealerstocks.map((item) => item[name] || 0), // Handle missing keys by using 0
      }));

      this.updateDealerwiseStockChart(categories, seriesData);
    }
    if (
      prevProps.LoyalityName !== this.props.LoyalityName ||
      prevProps.LoyalityPoint !== this.props.LoyalityPoint
    ) {
      this.updateTopLoyaltyAchieverChart(
        this.props.LoyalityName,
        this.props.LoyalityPoint
      );
    }

    if (this.props.MappingData) {
      if (prevProps.MappingData !== this.props.MappingData) {
        // this.props.myProp has a different value
        if (this.props.MappingData) {
          var e = this.props.MappingData;
          this.setState({
            totalRecords: e[0].TotalRows,
          });
        }
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0,
        });
    }

    if (prevProps.MaxFromNo !== this.props.MaxFromNo) {
      this.setState({
        FromNo: this.props.MaxFromNo,
      });
    }

    if (
      prevProps.MappingChart !== this.props.MappingChart &&
      prevProps.DeMappingChart !== this.props.DeMappingChart
    ) {
      this.setState({
        FromNo: this.props.MaxFromNo,
      });

      this.setState({
        series: [
          { name: "Mapping", data: this.props.MappingChart },
          { name: "DeMapping", data: this.props.DeMappingChart },
        ],
      });
    }
    // if(prevProps.)
    if (prevProps.AverageRating !== this.props.AverageRating) {
      this.setState({
        FromNo: this.props.MaxFromNo,
      });

      this.setState({});
    }
  }

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
    this.props.TopfetchLoyalityPointApi(this.tblResponse);
  }
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.fetchApi(this.tblResponse);
    this.props.TopfetchLoyalityPointApi(this.tblResponse);
  }
  onPage(event) {
    //imitate delay of a backend call
    this.getLazyLoadingValues(event);
    //this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
    this.props.TopfetchLoyalityPointApi(this.tb);
  }
  // Function to toggle the visibility
  toggleCardVisibility = () => {
    this.setState((prevState) => ({
      isCardVisible: !prevState.isCardVisible,
    }));
  };
  render() {
    const { dealerwiseStockChart } = this.state;
    return (
      <main className="">
        <div className="box-shadowe box-space">
          <div className="containter-fluid">
            <div className="row">
              <div className="col-md-4">
                <div
                  className="cards"
                  style={{ height: "250px", overflow: "hidden" }}
                >
                  <h2>Top scan products</h2>
                  <ReactApexChart
                    style={{ margin: "0", display: "block", maxWidth: "600px" }}
                    options={{
                      chart: {
                        type: "donut",
                        width: "100%",
                        height: 500,
                      },
                      labels: this.props.ProductNames || [],
                      responsive: [
                        {
                          breakpoint: 480,
                          options: {
                            chart: {
                              width: "100%", // Adjust width for smaller screens
                            },
                            legend: {
                              position: "bottom",
                            },
                          },
                        },
                      ],
                      colors: [
                        "#a86464",
                        "#98d1d1",
                        "#3c4e4b",
                        "#e27c7c",
                        "#d2980d",
                        "#df979e",
                        "#d7658b",
                        "#c80064",
                      ],
                      legend: {
                        // position: "bottom", // Position the labels at the bottom
                        // labels: {
                        //   fontSize: "14px", // Adjust font size if needed
                        // },
                        show: false,
                      },
                      plotOptions: {
                        pie: {
                          donut: {
                            size: "40%", // Adjust donut size
                            labels: {
                              show: false,
                              name: {
                                show: false,
                              },
                              value: {
                                show: true,
                              },
                              // total: {
                              //   show: true,
                              //   label: 'Total',
                              // },
                            },
                          },
                        },
                      },
                      tooltip: {
                        theme: "dark",
                        y: {
                          formatter: (value) => `${value}`,
                        },
                      },
                      shadow: {
                        enabled: true, // Enable shadow
                        blur: 5, // Apply blur to the shadow for a 3D look
                        color: "rgba(0, 0, 0, 0.3)", // Set shadow color
                        opacity: 0.3, // Set shadow opacity
                      },
                    }}
                    series={this.props.ScanCounts || []}
                    type="donut"
                    height="100%" // Increase height for a larger donut
                    width="100%" // Ensure width matches the chart size
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className="cards"
                  style={{ height: "250px", overflow: "hidden" }}
                >
                  <a href="masters/mobile-user-master">
                    <div className="row mt-2">
                      <div className="col-md-2 n_iconscol">
                        <i className="bi bi-list-ol" />
                      </div>
                      <div className="col-md-7 n_issuehcol">Active Dealer</div>
                      <div className="col-md-2 n_issuencol">
                        <h4>
                          {" "}
                          {this.props.TotalDealer ? this.props.TotalDealer : 0}
                        </h4>
                      </div>
                    </div>
                  </a>
                  <a href="masters/mobile-user-master">
                    <div className="row mt-2">
                      <div className="col-md-2 n_iconscol">
                        <i className="bi bi-list-ol" />
                      </div>
                      <div className="col-md-7 n_issuehcol">
                        Active Contractor
                      </div>
                      <div className="col-md-2 n_issuencol">
                        <h4>
                          {" "}
                          {this.props.TotalContractor
                            ? this.props.TotalContractor
                            : 0}
                        </h4>
                      </div>
                    </div>
                  </a>
                  <a href="masters/user-approval">
                    <div className="row mt-2">
                      <div className="col-md-2 n_iconscol">
                        <i className="bi bi-list-ol" />
                      </div>
                      <div className="col-md-7 n_issuehcol">
                        Inactive Dealer
                      </div>
                      <div className="col-md-2 n_issuencol">
                        <h4>
                          {" "}
                          {this.props.TotalPendingDealer
                            ? this.props.TotalPendingDealer
                            : 0}
                        </h4>
                      </div>
                    </div>
                  </a>
                  <a href="masters/user-approval">
                    <div className="row mt-2">
                      <div className="col-md-2 n_iconscol">
                        <i className="bi bi-list-ol" />
                      </div>
                      <div className="col-md-7 n_issuehcol">
                        Inactive Contractor
                      </div>
                      <div className="col-md-2 n_issuencol">
                        <h4>
                          {" "}
                          {this.props.TotalPendingContractor
                            ? this.props.TotalPendingContractor
                            : 0}
                        </h4>
                      </div>
                    </div>
                  </a>

                  <a href="masters/Group-Master">
                    <div className="row mt-2">
                      <div className="col-md-2 n_iconscol">
                        <i class="bi bi-people"></i>
                      </div>
                      <div className="col-md-7 n_issuehcol">Total Group</div>
                      <div className="col-md-2 n_issuencol">
                        <h4>
                          {" "}
                          {this.props.TotalGroup ? this.props.TotalGroup : 0}
                        </h4>
                      </div>
                    </div>
                  </a>
                  {/* <Chart
                    style={{ height: "170px" }}
                    type="pie"
                    data={{
                      // datasets: [
                      //   {
                      //     label: this.props.ProductNames || [],
                      //     data: this.props.ScanCounts || [],
                      //     backgroundColor: [
                      //       "#1c62ae",
                      //       "#fff500",
                      //       "#3c4e4b",
                      //       "#e27c7c",
                      //       "#d2980d",
                      //       "#df979e",
                      //       "#d7658b",
                      //       "#c80064",
                      //     ],
                      //     hoverOffset: 4,
                      //   },
                      // ],
                      datasets:[
                        {
                          label: this.props.AverageRating ||[],
                          backgroundColor: [
                            "#1c62ae",
                            "#fff500",
                            "#3c4e4b",
                            "#e27c7c",
                            "#d2980d",
                            "#df979e",
                            "#d7658b",
                            "#c80064",
                          ],
                          hoverOffset: 4,
                        }
                      ],
                      label:this.props.ProductNames || []
                    }}
                    options={{
                      plugins: {
                        legend: {
                          position: "right", // Position the labels on the right
                          labels: {
                            font: {
                              size: 20, // Adjust the font size if needed
                            },
                          },
                        },
                        tooltip: {
                          callbacks: {
                            label: function (tooltipItem) {
                              // Show the product name along with the scan count
                              let productName = tooltipItem.label || '';
                              let averageRating = tooltipItem.raw || 0;
                              return `${productName}: ${averageRating}`; // Format the tooltip to show product name and scan count
                            },
                          },
                        },
                      },
                      responsive: true,
                      maintainAspectRatio: false,
                    }}
                    height="100%"// Increase height for a larger donut
                    width="100%" // Ensure width matches the chart size
                  />
 */}
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className="cards"
                  style={{ height: "250px", overflow: "hidden" }}
                >
                 
                    <div className="row mt-2">
                      <div className="col-md-2 n_iconscol">
                        <i className="bi bi-list-ol" />
                      </div>
                      <div className="col-md-7 n_issuehcol">Number Issues</div>
                      <div className="col-md-2 n_issuencol">
                        <h4>
                          {" "}
                          {this.props.TotalIssue ? this.props.TotalIssue : 0}
                        </h4>
                      </div>
                    </div>
                 
                  <a href=" transactions/mapping">
                    <div className="row mt-2">
                      <div className="col-md-2 mapping_iconscol">
                        <i className="fa fa-cube" />
                      </div>
                      <div className="col-md-7 n_issuehcol">Mapping</div>
                      <div className="col-md-2 mapping_ncol">
                        <h4>
                          {" "}
                          {this.props.TotalMapping
                            ? this.props.TotalMapping
                            : 0}
                        </h4>
                      </div>
                    </div>
                  </a>
                  <a href="/transactions/de-mapping">
                    <div className="row mt-2">
                      <div className="col-md-2 demapping_iconscol">
                        <i className="fa fa-cubes" />
                      </div>
                      <div className="col-md-7 n_issuehcol">De Mapping</div>
                      <div className="col-md-2 demapping_ncol">
                        <h4>
                          {" "}
                          {this.props.TotalDeMapping
                            ? this.props.TotalDeMapping
                            : 0}
                        </h4>
                      </div>
                    </div>
                  </a>
                  <a href="transactions/damage">
                    <div className="row mt-2">
                      <div className="col-md-2 damage_iconscol">
                        <i
                          className="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        ></i>
                      </div>
                      <div className="col-md-7 n_issuehcol">Damage</div>
                      <div className="col-md-2 damage_ncol">
                        <h4>
                          {this.props.TotalDamage ? this.props.TotalDamage : 0}
                        </h4>
                      </div>
                    </div>
                  </a>
                  <a href="reports/verification-log">
                    <div className="row mt-2">
                      <div className="col-md-2 ts_iconscol ">
                        <i className="fa fa-qrcode" />
                      </div>
                      <div className="col-md-7 n_issuehcol">Total Scans</div>
                      <div className="col-md-2 ts_ncol">
                        <h4>
                          {this.props.TotalScans ? this.props.TotalScans : 0}
                        </h4>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="cards toployac">
                  <h2>Top Loyalty Achievers</h2>
                  <ReactApexChart
                    options={this.state.topLoyaltyAchieverChart.options}
                    series={this.state.topLoyaltyAchieverChart.series}
                    type="bar"
                    height={200}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div
                  className="cards"
                  style={{ height: "250px", overflow: "hidden" }}
                >
                  <h2>Dealerwise Stock</h2>
                  <ReactApexChart
                    options={dealerwiseStockChart.options}
                    series={dealerwiseStockChart.series}
                    type="area"
                    height={200}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div
                  className="cards"
                  style={{ height: "300px", overflow: "hidden" }}
                >
                  <h2>Mappings Trends</h2>
                  <ReactApexChart
                    // style={{ height: "300px" }}
                    // options={{
                    //   chart: {
                    //     height: 250,
                    //     type: "area",
                    //     zoom: { enabled: false }
                    //   },
                    //   dataLabels: { enabled: false },
                    //   stroke: { curve: "smooth" },
                    //   grid: {
                    //     row: { colors: ["#f3f3f3", "transparent"], opacity: 0.5 }
                    //   },
                    //   xaxis: {
                    //     categories: this.state.mappingTrends.MonthName || [], // Use dynamic categories
                    //   },
                    //   title: {
                    //     align: "center",
                    //   },
                    // }}
                    // series={this.state.mappingTrends.series || []} // Use dynamic series data
                    // type="area"
                    // height={250}
                    style={{ height: "300px" }}
                    options={this.state.options}
                    series={this.state.series}
                    type="area"
                    height={250}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => {
  console.log("data", state.dashboard);
  return {
    DashboardList: state.dashboard?.items?.DashboardListData,
    TotalMapping: state.dashboard?.items?.DashboardCount?.TotalMapping,
    TotalGroup: state.dashboard?.items?.DealerCountDetails?.TotalGroup,
    TotalDeMapping: state.dashboard?.items?.DashboardCount?.TotalDeMapping,
    UserPendingApprovel:
      state.dashboard?.items?.DashboardCount?.UserPendingApprovel,
    TotalDamage: state.dashboard?.items?.DashboardCount?.TotalDamage,
    TotalScans: state.dashboard?.items?.DashboardCount?.TotalScans,
    TotalIssue: state.dashboard?.items?.DashboardCount?.TotalIssue,
    DeMappingChart: state.dashboard?.items?.DeMappingList,
    MappingChart: state.dashboard?.items?.MappingList,
    ProductNames: state.dashboard?.items?.ProductNames,
    ScanCounts: state.dashboard?.items?.ScanCounts,
    Months: state.dashboard?.items?.MonthName,
    MappingData: state.mapping.items,
    TotalContractor: state.dashboard?.items?.DealerCountDetails?.Contractor,
    TotalPendingContractor:
      state.dashboard?.items?.DealerCountDetails?.PendingContractor,
    TotalDealer: state.dashboard?.items?.DealerCountDetails?.Dealer,
    TotalPendingDealer:
      state.dashboard?.items?.DealerCountDetails?.PendingDealer,
    LoyalityName: state.dashboard?.items?.LoyalName,
    LoyalityPoint: state.dashboard?.items?.LoyalPoint,
    Dealerstocks: state.dashboard?.items?.SalesDataDtos,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(dashboardActions.fetchData(obj));
    },
    TopfetchLoyalityPointApi: (obj) => {
      dispatch(dashboardActions.TopfetchLoyalityPoint(obj));
    },
    fetchMappingApi: (obj) => {
      dispatch(mappingActions.getAll(obj));
    },
    fetchLoyalityApi: (obj) => {
      dispatch(UserloyalityLogRptActions.getAll(obj));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
